export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZvlNabidka';
export const NAME = 'ZvlastniNabidky';

export const BANNER_HEIGHT = 100;
export const BANNER_WIDTH = 992;
export const BASE64_PNG_PREFIX = 'data:image/png;base64,';
